import React from "react";

// GEMA wordmark — clean engineering-grade recreation of the brand mark.
export default function Logo({ className = "", light = true }) {
  const color = light ? "#FFFFFF" : "#0A0A0A";
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} data-testid="gema-logo">
      <span
        className="font-heading font-black tracking-tight text-2xl leading-none"
        style={{ color }}
      >
        GEMA
      </span>
      <span className="flex items-center" aria-hidden="true">
        <span className="h-px w-4 bg-gema-red" />
        <svg width="14" height="14" viewBox="0 0 24 24" className="mx-0.5">
          <path
            d="M12 2 L20 9 L12 22 L4 9 Z M4 9 L20 9 M12 2 L8 9 M12 2 L16 9 M8 9 L12 22 M16 9 L12 22"
            fill="none"
            stroke="#C1272D"
            strokeWidth="1.4"
            strokeLinejoin="round"
          />
        </svg>
        <span className="h-px w-4 bg-gema-red" />
      </span>
    </span>
  );
}
